import React from "react";
import { Modal, Pressable, Text, View } from "react-native";

import { PhoneNumberText, PrimaryButton } from "../../../../common/native";
import {
  ASSIGN_PHONE_OVERWRITE_PROMPT_MESSAGE,
  TPatientOption,
} from "../types";
import { styles } from "../HomeConversations.styles";
import { normalizePatientPhoneForCall } from "../utils/phones";

type AssignPhoneOverwriteModalProps = {
  visible: boolean;
  submitting: boolean;
  patient: TPatientOption | null;
  onRequestClose: () => void;
  onKeepExisting: () => void;
  onOverwrite: () => void;
};

const AssignPhoneOverwriteModal: React.FC<AssignPhoneOverwriteModalProps> = ({
  visible,
  submitting,
  patient,
  onRequestClose,
  onKeepExisting,
  onOverwrite,
}) => {
  const existingPhone = normalizePatientPhoneForCall(patient?.phone);

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onRequestClose}
    >
      <View style={styles.assignModalOverlay}>
        <View style={styles.assignModalCard}>
          <Text style={styles.cardTitle}>Overwrite Phone Number</Text>
          <Text style={styles.metaText}>
            {ASSIGN_PHONE_OVERWRITE_PROMPT_MESSAGE}
          </Text>
          <Text style={styles.metaText}>
            Patient: {patient?.displayName || patient?.uuid || "-"}
          </Text>
          <Text style={styles.metaText}>
            Existing number:{" "}
            {existingPhone ? (
              <PhoneNumberText value={existingPhone} style={styles.metaText} />
            ) : (
              "No phone on file"
            )}
          </Text>
          <View style={styles.assignModalActionsRow}>
            <Pressable
              style={[
                styles.assignModalSecondaryButton,
                submitting && styles.callAgainButtonDisabled,
              ]}
              onPress={onKeepExisting}
              disabled={submitting}
              accessibilityLabel="Keep existing patient phone number"
            >
              <Text style={styles.assignModalSecondaryButtonText}>No</Text>
            </Pressable>
            <PrimaryButton
              text="Yes"
              onPress={onOverwrite}
              loading={submitting}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default AssignPhoneOverwriteModal;
